export default __webpack_public_path__ + "static/ClippedStars-f2618f7efc6400a89f88561a11985df4.png";